import { render, staticRenderFns } from "./ListBudgets.vue?vue&type=template&id=ba15ccde"
import script from "./ListBudgets.vue?vue&type=script&lang=js"
export * from "./ListBudgets.vue?vue&type=script&lang=js"
import style0 from "./ListBudgets.vue?vue&type=style&index=0&id=ba15ccde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports